import { LandingContent } from "./types";

export const websiteSeoLanding: LandingContent = {
  ctaText: "Request a site audit",
  quickFacts: ["6-week launch", "Mobile-first", "Content included"],
  whyHeading: "Why teams use Website & Local SEO",
  why: "We've built 400+ contractor websites that average 7.8% visitor-to-call conversion — 3x the industry norm. Every site is engineered around three goals: get found on mobile search, get trusted in the first 5 seconds, and get a booked call. Local SEO, schema, and Google Business Profile optimization are all included.",
  advantages: [
    {
      title: "Conversion-engineered design",
      description:
        "Every template tested across hundreds of markets — click-to-call placement, trust signals, and service area clarity.",
      includedNote: "7.8% avg. visitor-to-call conversion",
    },
    {
      title: "Local SEO foundation",
      description:
        "Google Business Profile, Bing Places, Apple Maps, 75+ citations, and full schema markup set up and maintained monthly.",
      includedNote: "Mobile-first, Core Web Vitals optimized",
    },
    {
      title: "Monthly content",
      description:
        "Our team produces 2-4 service-specific articles per month to grow your long-tail organic traffic.",
      includedNote: "Schema + GMB + 75 citations included",
    },
  ],
  featureChecklist: [
    "7.8% avg. visitor-to-call conversion",
    "Mobile-first, Core Web Vitals optimized",
    "Schema + GMB + 75 citations included",
    "Monthly content production",
  ],
  highlights: [],
  steps: [
    {
      title: "Strategy & sitemap",
      description:
        "We map service areas, key pages, and the conversion path. Your input drives the brand voice.",
    },
    {
      title: "Design & build",
      description:
        "Mobile-first design built on our high-converting templates, customized to your brand.",
    },
    {
      title: "SEO foundation",
      description:
        "Google Business Profile, Bing Places, Apple Maps, schema, citations — all configured at launch.",
    },
    {
      title: "Ongoing content",
      description:
        "Monthly service-specific articles plus continuous local SEO maintenance.",
    },
  ],
  testimonials: [],
  faqs: [
    {
      question: "How long until launch?",
      answer:
        "Most sites launch within 6 weeks of kickoff. Local SEO foundation is configured before launch so you start ranking immediately.",
    },
    {
      question: "Do I own the site?",
      answer: "Yes. The site, the content, and the SEO work are all yours.",
    },
    {
      question: "Is content production really included?",
      answer:
        "Yes — 2 to 4 service-specific articles per month, written by humans who know the trades.",
    },
  ],
  closing: {
    heading: "Get found in your service area",
    body: "Request a free site audit — we'll show you exactly where your current site is leaving leads on the table.",
  },
};
